import { createRouter, createWebHistory } from 'vue-router';

import Login from '@/views/Login';
import Dashboard from '@/views/Dashboard';
import Tasks from '@/views/Tasks';
import TaskDetails from '@/views/TaskDetails';
import Clients from '@/views/Clients';
import Users from '@/views/Users';
import Settings from '@/views/Settings';
import Profile from '@/views/Profile.vue';
import ReportsWorkTask from '@/views/ReportsWorkTask.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
    meta: { requiresAuth: true },
  },
  {
    path: '/tasks/:id/:slug',
    name: 'TaskDetails',
    component: TaskDetails,
    meta: { requiresAuth: true },
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports/work-time',
    name: 'ReportsWorkTime',
    component: ReportsWorkTask,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Redireciona para o login se o usuário não estiver autenticado
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem('token')) {
    next('/login'); // Redireciona para a página de login
  } else {
    next(); // Deixa o usuário continuar na página
  }
});

export default router;
